package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

data class Comment(
    val id: Int,
    val postId: Int,
    val authorName: String,
    val content: String,
    val createdAt: Instant,
)
